import { Component, OnInit, Output, EventEmitter, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { retry } from 'rxjs/operators';
import { Configuration, ConfigurationService, TripService } from '../../../core';
import { SnackbarService } from '../../components/snackbar/snackbar.service';
import { Constants } from '../../../core';
@Component({
  standalone: false,
  selector: 'app-list-printers',
  templateUrl: './list-printers.component.html'
})
export class ListPrintersComponent implements OnInit, OnChanges {
  @Input() printType: Configuration;
  @Input() entity: any;
  @Input() column: any;
  @Input() module: any;
  @Output() correlativeAndPrinter = new EventEmitter<any>();
  public inputPrinter: string;
  public listPrinters: any[];
  public form: FormGroup;
  codeGuiaCurrent: any;
  isGuideEditable: any;
  isGRI: any;
  guidePlatform: Configuration;
  constructor(
    public tripService: TripService,
    public snackbarService: SnackbarService,
    public configurationService: ConfigurationService,
    public fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.form = this.fb.group({
      guidePlatform: [''],
      serialNumber: [''], /* ===, [Validators.required, Validators.minLength(3), Validators.maxLength(6)] */
      codeGuia: [null, [Validators.required, Validators.minLength(7), Validators.maxLength(7), Validators.pattern('^[0-9\\s]+$')]],
      inputPrinter: [''],
    });
  }

  ngOnChanges() {
    this.getPrinters(this.entity);
  }

  ngOnInit() {
    this.printType? this.setPrintTypeSettings(): this.readGeneralConfigurations();
    this.form.valueChanges.subscribe(change => {
      if (this.form.valid) {
        // if(this.form.controls['codeGuia'].value < this.codeGuiaCurrent)
        //   this.correlativeAndPrinter.emit(null);
        // else
        this.correlativeAndPrinter.emit(change);
      } else {
        this.correlativeAndPrinter.emit(null);
      }
    });
  }

  setPrintTypeSettings(){
    this.isGRI = this.module === Constants.ReasonPrint.GRI;
    this.guidePlatform = this.printType;
    this.isGuideEditable = this.guidePlatform.configValue === Constants.ReasonPrint.PLATFORM_CUPS;
    this.getPrinters(this.entity);
  }

  readGeneralConfigurations() {
    this.configurationService
      .read('GENERAL_CONFIG')
      .subscribe(configurations => {
        this.isGRI = this.module === Constants.ReasonPrint.GRI;
        this.guidePlatform = configurations.find(configuration => configuration.configName === 'GUIDE_PLATFORM');
        this.isGuideEditable = this.guidePlatform.configValue === Constants.ReasonPrint.PLATFORM_CUPS;
        this.getPrinters(this.entity);
      });
  }

  getPrinters(entity) {
    if(this.guidePlatform) {
      this.tripService.getPrinters(this.guidePlatform.configValue, entity)
      .pipe(
        retry(1)
      ).subscribe(printers => {
        this.listPrinters = printers.printers;
        // this.correlative.emit(printers.correlative);
        this.getCorrelative(printers);
        this.cdr.markForCheck();
      }, error => {
        this.snackbarService.show('Error en el servidor de impresoras', 'error');
      });
    }
  }

  getCorrelative(data) {
    const formart = data.correlative ? data.correlative.split('-') : [""];
    const correlative = formart.length === 1 ? formart[0] : formart[1];

    this.form.patchValue({
      serialNumber: data.serialNumber,
      guidePlatform: this.guidePlatform.configValue,
      codeGuia: correlative
    });
    this.codeGuiaCurrent = correlative;
  }
}
